import { IconButton, Stack } from "@mui/material";
import { useClipboardCopy } from "@/hooks/useClipboardCopy";
import { useTranslation } from "react-i18next";
import { Icon, Typography } from "@trimble/modus-cmx";

type CopyableEmailProps = {
  email: string;
  children?: React.ReactNode;
  slotProps?: {
    typography: React.ComponentProps<typeof Typography> &
      Record<`data-${string}`, string>;
  };
};

const CopyableEmail = (props: CopyableEmailProps) => {
  const { email, children, slotProps } = props;

  const { copy } = useClipboardCopy();
  const { t } = useTranslation();

  const handleCopy = (event: React.MouseEvent) => {
    event.stopPropagation();
    copy(email, t("copyable_email.copied_email_address_to_clipboard"));
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        display: "inline-flex",
        minWidth: 0,
        maxWidth: "100%",
        "& .copyable-email-copy-btn": {
          opacity: 0,
          pointerEvents: "none",
        },
        "&:hover .copyable-email-copy-btn, &:focus-within .copyable-email-copy-btn":
          {
            opacity: 1,
            pointerEvents: "auto",
          },
      }}
    >
      <Typography title={email} noWrap {...slotProps?.typography}>
        {children ?? email}
      </Typography>
      <IconButton
        className="copyable-email-copy-btn"
        size="small"
        onClick={handleCopy}
        color="primary"
        aria-label={t("copyable_email.copy_email")}
        title={t("copyable_email.copy_email")}
      >
        <Icon name="copy_content" size="sm" />
      </IconButton>
    </Stack>
  );
};

export default CopyableEmail;
